import classNames from 'classnames';

import IconButton from 'components/partials/button/icon-button';

import type { CeebCodeChip as CeebCodeChipModel } from '../calculations-step.types';

import Icons from 'assets/icons';

export interface CeebCodeChipProps {
  chip: CeebCodeChipModel;
  onRemove: (id: string) => void;
}

/** One chip in the CEEB codes field: pending (spinner), matched (neutral), or unmatched (warning) — FR-15/17/18/19. */
const CeebCodeChip = ({ chip, onRemove }: CeebCodeChipProps) => {
  const isUnmatched = chip.status === 'unmatched';
  const isPending = chip.status === 'pending';

  return (
    <span
      className={classNames(
        'inline-flex items-center gap-1 rounded-md border pl-2.5 pr-1.5 py-1 text-sm',
        isUnmatched
          ? 'border-critical-200 text-critical-600'
          : 'border-navy-200 text-gray-900'
      )}
      data-testid={`ceeb-code-chip-${chip.id}`}
      data-status={chip.status}
    >
      {chip.code}
      {isPending ? (
        <Icons.Spinner
          customClass="size-3 animate-spin text-gray-400"
          data-testid={`ceeb-code-chip-pending-${chip.id}`}
        />
      ) : (
        <IconButton
          icon={<Icons.Close />}
          variant={isUnmatched ? 'critical-text' : 'reserve-text'}
          size="baby"
          aria-label={`Remove CEEB code ${chip.code}`}
          onClick={() => onRemove(chip.id)}
          className="text-current size-3"
          data-testid={`ceeb-code-chip-remove-${chip.id}`}
        />
      )}
    </span>
  );
};

export default CeebCodeChip;
